import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import { useProjectStore, useViewStore } from '../stores';
import { useApi } from './useApi';
import { useCurrencyStore, useTenantStore } from '../stores';
import { useRouter } from 'next/router';
import { isValidClassification } from '../utils/projectV2';

export const useInitializeProject = () => {
  const locale = useLocale();
  const tenantId = useTenantStore((state) => state.tenantConfig.id);
  const { getApi } = useApi();
  const router = useRouter();
  // store: state
  const currencyCode = useCurrencyStore((state) => state.currencyCode);
  const currentPage = useViewStore((state) => state.page);
  const projectsCurrencyCode = useProjectStore(
    (state) => state.projectsCurrencyCode
  );
  const projectsLocale = useProjectStore((state) => state.projectsLocale);
  const projects = useProjectStore((state) => state.projects);
  // store: action
  const fetchProjects = useProjectStore((state) => state.fetchProjects);
  const setSelectedClassification = useProjectStore(
    (state) => state.setSelectedClassification
  );
  const setShowDonatableProjects = useProjectStore(
    (state) => state.setShowDonatableProjects
  );
  const clearFilterStates = useProjectStore((state) => state.clearFilterStates);

  useEffect(() => {
    if (currentPage !== 'project-list' || !currencyCode) return;
    // Avoid refetching if projects are already loaded for the same locale and currency
    if (
      projectsLocale === locale &&
      projectsCurrencyCode === currencyCode &&
      projects !== null
    )
      return;

    fetchProjects(getApi, {
      queryParams: {
        _scope: 'map',
        currency: currencyCode,
        //passing locale/tenant as a query param to break cache when locale changes,
        //as the browser uses the cached response even though the x-locale header is different
        locale,
        tenant: tenantId,
        'filter[purpose]': 'trees,conservation',
      },
    });
  }, [currencyCode, locale, tenantId, currentPage]);

  useEffect(() => {
    if (router.isReady && currentPage === 'project-list') {
      const { filter, donatable_projects_only } = router.query;

      // Initialize classification filters from URL
      if (filter) {
        const filterValues = typeof filter === 'string' ? [filter] : filter;
        const validFilters = filterValues.filter(isValidClassification);

        if (validFilters.length > 0) {
          setSelectedClassification(validFilters);
        }
      }

      // Initialize donation filter from URL
      if (donatable_projects_only === 'true') {
        setShowDonatableProjects(true);
      }
    }
    // `currentPage` starts as `null` and is resolved by `useInitializeView` once the router is ready; include it so the URL filters initialize when the page becomes 'project-list' (not only on the initial `router.isReady`).
  }, [router.isReady, currentPage]);

  useEffect(() => {
    if (currentPage === 'project-details') clearFilterStates();
  }, [currentPage]);
};
